/**
 * Created by contrapro on 03/04/2018
 */

// TODO: 改用node的环境变量，而非写死
export const HOST_ENV = process.env.REACT_APP_RELEASE_ENV ? process.env.REACT_APP_RELEASE_ENV : process.env.NODE_ENV; //'production'; //production //staging


// WEBPACK FOOTER //
// ./src/cfg.js